import MomentUtils from "@date-io/moment";
import CssBaseline from "@material-ui/core/CssBaseline";
import { ThemeProvider } from "@material-ui/core/styles";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { SnackbarProvider } from "notistack";
import React, { useRef } from "react";
import ReactDOM from "react-dom";
import { Provider as ReduxProvider, connect, ConnectedProps } from "react-redux";
import { BrowserRouter as Router, Route } from "react-router-dom";
import "./Client/client.css";
import ClientApp from "./Client/Components/ClientApp";
import configureStore from "./Client/redux/configureStore";
import theme from "./Client/theme";
import Notifier from "./Shared/Components/Notifier";
import Fullscreen from "react-full-screen";
import { Settings } from "./Shared/GeneratedTypes";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ApplicationData } from "./Client/types";
import { setFullScreen, setFullscreenContainer } from "./Client/redux/actions/uxActions";
import FullscreenContext from "./Client/FullscreenContext";
import ApplicationInsightsContext from "./Shared/Components/ApplicationInsightsContext";
import { Close } from "@material-ui/icons";
import { closeSnackbar } from "./Shared/Redux/Actions/notificationActions";

let guideStreamSettings = (window as any).GuideStream.settings as Settings;
//https://docs.microsoft.com/en-us/azure/azure-monitor/app/javascript#npm-based-setup
const appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: guideStreamSettings.instrumentationKey,
        autoTrackPageVisitTime: true,
    },
});
appInsights.loadAppInsights();
appInsights.trackPageView();

(window as any).appInsights = appInsights;

// import * as serviceWorker from './serviceWorker';

//@ts-ignore
const store = configureStore();
const mapState = function ({ fullscreen }: ApplicationData) {
    return { fullscreen };
};
const mapDispatch = {
    setFullScreen,
    setFullscreenContainer,
    closeSnackbar
};
const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>;
type PropTypes = PropsFromRedux & {};
function App({ fullscreen, setFullScreen, setFullscreenContainer, closeSnackbar }: PropTypes) {
    const containerRef = useRef<Fullscreen | null>(null);

    return (
        <Fullscreen
            enabled={fullscreen}
            ref={containerRef}
            onChange={(isFull) => {
                setFullScreen(isFull);
            }}
        >
            <FullscreenContext.Provider value={containerRef}>
                <SnackbarProvider
                    dense
                    anchorOrigin={{ vertical: "top", horizontal: "left" }}
                    className="alert-position"
                    action={(snackbarId) => (
                        <Close
                            onClick={() => closeSnackbar(snackbarId)}
                            style={{cursor: 'pointer'}}
                        />
                    )}
                >
                    <Notifier />
                    <CssBaseline />
                    <Route path="/client.html" component={ClientApp}></Route>
                </SnackbarProvider>
            </FullscreenContext.Provider>
        </Fullscreen>
    );
}

const ConnectedApp = connector(App);

ReactDOM.render(
    <ApplicationInsightsContext.Provider value={appInsights}>
        <ReduxProvider store={store}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
                <ThemeProvider theme={theme}>
                    <Router>
                        <ConnectedApp />
                    </Router>
                </ThemeProvider>
            </MuiPickersUtilsProvider>
        </ReduxProvider>
    </ApplicationInsightsContext.Provider>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
